// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".support__inner{padding-bottom:2.5rem;padding-top:2.5rem}.support__inner h2{color:var(--g-color-primary)}.support__inner a:not(.btn):not(.v-button){-webkit-text-decoration:underline;text-decoration:underline}.support__inner img{height:auto;max-width:100%}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
